<template>
	<div class="home">
		<div class="home-container">
			<div class="home-left">
				<div class="info-box">
					<div class="home-title" style="justify-content:space-between;">今日概况
						<el-button type="text" v-if="enterpriseDataFlag === 1" @click="changeShop(0)">切换为当前店铺</el-button>
						<el-button type="text" v-if="enterpriseDataFlag === 0" @click="changeShop(1)">切换为所有店铺</el-button>
					</div>
					<div class="allinfo-detail">
						<div v-for="item in currentData" :key="item.name">
							<div class="allinfo-wrap">
								<div class="info-figure"><span>{{AuthorityList['14_0001_0000_00'] ? item.count : 0}}</span> {{item.unit}}</div>
								<div class="info-name">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="home-order">
					<div class="order-content">
						<div class="home-title">待办事项</div>
						<div class="order-detail">
							<div v-for="item in orderMenu" :key="item.billState" @click="goOrder(item)">
								<div class="img-wrap"><img :src="item.src" alt=""></div>{{item.name}}<span v-if="item.count !== 0 && item.countFlag">{{item.count > 99 ? '99+' : item.count}}</span>
							</div>
						</div>
					</div>
					<div class="form-content">
						<div class="home-title">我的报表<span class="home-titmore" @click="goRouter('reportform/orderDetail',2,'09_0000_0000_00')">更多 ></span></div>
						<div class="form-detail">
							<div><img src="~/images/img/shop-form.png" alt="" @click="goRouter('reportform/goodMarketNew',2,'09_0001_0008_00')">商品销售统计表</div>
							<div><img src="~/images/img/product-form.png" alt="" @click="goRouter('reportform/orderDetail',2,'09_0001_0006_00')">订单明细对账表</div>
							<div><img src="~/images/img/dan-form.png" alt="" @click="goRouter('reportform/orderResume',2,'09_0001_0007_00')">订单概要对账表</div>
							<div><img src="~/images/img/ding-form.png" alt="" @click="goRouter('reportform/customSaleNew',2,'09_0001_0009_00')">客户销售统计表</div>
						</div>
					</div>
				</div>
				<div class="home-chart" id="chartWrap">
					<div style="padding: 0 15px;box-sizing:border-box">
						<div class="home-title">经营概况</div>
					</div>
					<div id="myChart" style="height:400px;"></div>
					<div class="chart-month">
						<span>日期:</span>
						<el-date-picker
							@change="searchTime"
							v-model="dateValue"
							:clearable="false"
							class="time-input"
							size="small"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
					</div>
					<div class="chart-order">
						<el-select v-model="value" placeholder="请选择" size="mini" @change="changeType">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
						<span v-show="value === '2'">当天销售商品</span>
						<span v-show="value === '0'">当天创建订单个数</span>
						<span v-show="value === '1'">当天创建订单的金额合计</span>
					</div>
				</div>
			</div>
			<div class="home-right">
				<div class="ad-box" @click="showAd">
					<w-image class="ad-img" src="https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/ad/mainimg.png"/>
				</div>
				<div class="home-account">
					<div class="home-title">您好,{{entName}}</div>
					<div class="account-info">
						<div><span>店铺名称：</span>{{shopName}}</div>
						<div><span>员工名称：</span>{{userName}}</div>
						<div><span>登录账号：</span>{{tel}}</div>
					</div>
				</div>
				<div class="waring-box" v-if="showWaring" @click="waringClick">
					<div class="home-title">预警通知</div>
					<div class="waring-detial">
						<div class="waring-title">
							<img style="margin-right: 5px;" src="~/images/icon/waring-icon.png" />
							专有价格预警
						</div>
						<div class="waring-text">
							您有
							<span style="font-size: 15px;color: #FCA40E;">{{waringNum}}</span>
							个商品的失效时间达到预警状态，请及时处理！
						</div>
					</div>
				</div>
				<div class="home-message" :style="'height:' + height + 'px'">
					<div class="home-title">消息通知<span class="unread-count"><span style="font-weight:bold">{{count}}</span> 条未读消息</span><span class="home-titmore" @click="goRouter('msgCenter', 3, '12_0001_0000_00')">更多 ></span></div>
					<div class="home-msg-content" v-if="!showWaring">
						<div class="home-msg-detail" v-for="item in msgList" :key="item.id" @click="goDetail(item)">
							<div class="home-msg-first">{{item.header}}</div>
							<div class="home-msg-second">{{item.message_alert}}</div>
							<div class="home-msg-third">订单编号: {{item.message_title}}</div>
							<div class="home-msg-third">推送时间: {{item.modifydate}}</div>
							<div class="unread-sign">{{item.readflag === 0 ? '未读':'已读'}}</div>
						</div>
					</div>
					<div class="home-msg-content" v-else>
						<div class="home-msg-detail" v-for="item in msgList.slice(0,2)" :key="item.id" @click="goDetail(item)">
							<div class="home-msg-first">{{item.header}}</div>
							<div class="home-msg-second">{{item.message_alert}}</div>
							<div class="home-msg-third">订单编号: {{item.message_title}}</div>
							<div class="home-msg-third">推送时间: {{item.modifydate}}</div>
							<div class="unread-sign">{{item.readflag === 0 ? '未读':'已读'}}</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog class="detail-dialog-title" title="温馨提示" :visible.sync="showGroupWaring" width='500px' :close-on-click-modal="false">
				<div class="tip-text">
					{{ waringDay }}
				</div>
				<div class="tip-btn">
					<el-button size="small" @click="todayNoTips">今日不再提示</el-button>
					<el-button size="small" type="primary" @click="closeGroupDialog">知道了</el-button>
				</div>
			</el-dialog>
			<el-dialog custom-class="ad-dialog" :visible.sync="adShow" width='450px' :close-on-click-modal="false">
				<w-image class="ad-detail" src="https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/ad/detail.png"/>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	name: 'home',
	data () {
		return {
			waringDay: '',
			showGroupWaring: false,
			showWaring: true,
			height: 490,
			waringNum: 0,
			shopOptions: [],
			sellerShopId: '',
			shopid: '',
			count: 0,
			msgList: [],
			orderMenu: [
				{ name: '待付款', orderStatus: 0, billState: 0, count: 0, countFlag: false, isSellerpull: false, authorityShow: false, src: require('$assets/images/img/fu-icon.png') },
				{ name: '待接单', orderStatus: 1, billState: 1, count: 0, countFlag: false, isSellerpull: false, authorityShow: false, src: require('$assets/images/img/jie-icon.png') },
				{ name: '待发货', orderStatus: 2, billState: 2, count: 0, countFlag: false, isSellerpull: false, authorityShow: false, src: require('$assets/images/img/fa-icon.png') },
				{ name: '备货中', orderStatus: 2, billState: 4, count: 0, countFlag: false, isSellerpull: true, authorityShow: false, src: require('$assets/images/img/bei-icon.png') },
				{ name: '退货单', orderStatus: 99, billState: 99, count: 0, countFlag: true, isSellerpull: false, authorityShow: false, src: require('$assets/images/img/tui-icon.png') }
			],
			dateValue: [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrent()],
			options: [
				{
					value: '2',
					label: '动销率(%)'
				},
				{
					value: '0',
					label: '订单数(单)'
				}, {
					value: '1',
					label: '订单额(元)'
				}
			],
			value: '2',
			monthVal: '',
			currentData: [{
				name: '在售商品数',
				unit: '个',
				count: 0
			}, {
				name: '新增客户数',
				unit: '个',
				count: 0
			}, {
				name: '客户总数',
				unit: '个',
				count: 0
			}, {
				name: '本月待发货订单',
				unit: '单',
				count: 0
			}, {
				name: '本月备货订单',
				unit: '单',
				count: 0
			}, {
				name: '本月线上支付金额',
				unit: '元',
				count: 0
			}, {
				name: '本月合计销售额',
				unit: '元',
				count: 0
			}],
			dateNunber: [],
			dateTime: [],
			iosUrl: '',
			androidUrl: '',
			AuthorityList: {
				'07_0000_0000_00': false,
				'07_0001_0000_00': false,
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0002_0000_00': false,
				'07_0002_0001_00': false,
				'09_0000_0000_00': false,
				'09_0001_0000_00': false,
				'09_0001_0001_00': false,
				'09_0001_0002_00': false,
				'09_0001_0003_00': false,
				'09_0001_0004_00': false,
				'09_0001_0005_00': false,
				'12_0001_0000_00': false,
				'14_0001_0000_00': false,
				'14_0002_0000_00': false
			},
			entName: '',
			shopName: '',
			tel: '',
			userName: '',
			expirationdate: -1,
			enterpriseDataFlag: 0,
			matchbillcenterpriceflag: 1,
			adShow: false
		}
	},
	created () {
		this.checkSmallCategory()
		this.$fxEventBus.$emit('setMenu', '1')
		this.initUserAuthority()
		this.findShopList().then((data) => {
			if (data.length > 0) {
				this.shopOptions = data
				window.sessionStorage.setItem('storeid', data[0].shopId)
				if (window.sessionStorage.getItem('organid')) {
					this.sellerShopId = window.sessionStorage.getItem('organid')
					this.shopOptions.forEach(e => {
						if (this.sellerShopId === e.organid) {
							this.shopid = e.shopId
						}
					})
				} else {
					this.sellerShopId = data[0].organid
					this.shopid = data[0].shopId
					window.sessionStorage.setItem('organid', this.sellerShopId)
				}
				this.findCount()
				this.getRightinfo()
				this.getCurrentData()
				this.getDrawData()
				this.getMessage()
				this.getWaringNum()
			}
		})
		this.getGroup()
	},
	mounted () {
		let _this = this
		let chartBox = document.querySelector('#chartWrap')
		let myChartsize = document.querySelector('#myChart')
		let echarts = this.$echarts.init(document.getElementById('myChart'))
		window.onresize = () => {
			_this.chartssize(chartBox, myChartsize)
			echarts.resize()
		}
	},
	methods: {
		closeGroupDialog () {
			this.showGroupWaring = false
		},
		todayNoTips () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/homepage/set/remindme`
			}).then(res => {
				if (res.result) {
					this.showGroupWaring = false
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		showAd () {
			this.adShow = true
		},
		waringClick () {
			this.$router.push('exclusivePrice?isWaring="true"')
		},
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterpriceflag = res.matchbillcenterpriceflag
			})
			// })
		},
		getGroup () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/homepage/check/expiretiondate`
			}).then(res => {
				if (res.result) {
					if (res.data !== null) {
						this.showGroupWaring = true
						this.waringDay = res.data
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getWaringNum () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/homepage/privatepricewarning/count/get`
			}).then(res => {
				if (res.result) {
					this.waringNum = res.data
					if (this.waringNum > 0 && this.matchbillcenterpriceflag !== 1) {
						this.showWaring = true
						this.height = 335
					} else {
						this.showWaring = false
						this.height = 515
					}
				}
			})
		},
		searchTime () {
			if (this.checkTime()) {
				this.getDrawData()
			}
		},
		checkTime () {
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于3个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr1[0] === arr2[0]) { // 同年
				if (arr2[1] - arr1[1] > 3) { // 月间隔超过6个月
					flag = false
				} else if (arr2[1] - arr1[1] === 3) { // 月相隔6个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			} else { // 不同年
				if (arr2[0] - arr1[0] > 1) {
					flag = false
				} else if (arr2[0] - arr1[0] === 1) {
					if (arr1[1] + 3 - arr2[1] < 12) { // 月相隔大于3个月
						flag = false
					} else if (arr1[1] + 3 - arr2[1] === 12) { // 月相隔3个月，比较日
						if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
							flag = false
						}
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过3个月！')
				return false
			}
			return true
		},
		getSixMonth () {
			var data = new Date()
			var year = data.getFullYear()
			var mon = data.getMonth() + 2
			for (var i = 0; i < 6; i++) {
				this.monthArr[i] = {}
				mon = mon - 1
				if (mon <= 0) {
					year = year - 1
					mon = mon + 12
				}
				if (mon < 10) {
					mon = '0' + mon
				}
				let time = year + '-' + mon
				this.monthArr[i].value = year + '年' + mon + '月'
				this.monthArr[i].start = this.$fxUtils.getCurrentMonthFirst(time)
				this.monthArr[i].end = this.$fxUtils.getCurrentMonthLast(time)
				this.monthArr[i].index = i
			}
			this.monthVal = 0
		},
		getDrawData () {
			let params
			params = {
				dateType: this.value,
				sellerShopId: this.shopid,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				enterpriseDataFlag: this.enterpriseDataFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/homepage/linechart/get`,
				data: params
			}).then(res => {
				if (res.result) {
					this.dateTime = res.data.date
					if (this.AuthorityList['14_0002_0000_00']) {
						this.dateNunber = res.data.number
					} else {
						this.dateNunber = new Array(res.data.number.length).fill(0)
					}
					this.expirationdate = res.data.expirationdate
					this.drawLine()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getRightinfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/homepage/rightinfo`
			}).then(res => {
				if (res.result) {
					this.entName = res.data.entName
					this.shopName = res.data.shopName
					this.tel = res.data.tel
					this.userName = res.data.userName
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		findCount () {
			let params
			params = {
				ifBuyer: false,
				// sellerShopId: this.shopid,
				isSellerpull: false,
				enterpriseDataFlag: this.enterpriseDataFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findcount`,
				data: params,
				loading: false
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						this.orderMenu.forEach(menuItem => {
							if (item.billState === menuItem.billState) {
								menuItem.count = item.count
							}
						})
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getCurrentData () {
			let params = {
				id: this.shopid,
				beginDate: this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				enterpriseDataFlag: this.enterpriseDataFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/homepage/currentmonthdata`,
				data: params,
				loading: false
			}).then(res => {
				if (res.result === true) {
					this.currentData.forEach(e => {
						res.data.forEach(item => {
							if (e.name === item.name) {
								e.count = item.count
							}
						})
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getDownload () {
			let filename = window.sessionStorage.getItem('filename')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/admin/business/private/platform/download/` + filename
			}).then(res => {
				if (res.result === true) {
					if (res.data[0].type === 2) {
						this.iosUrl = res.data[1].qrcodeurl
						this.androidUrl = res.data[0].qrcodeurl
					} else {
						this.iosUrl = res.data[0].qrcodeurl
						this.androidUrl = res.data[1].qrcodeurl
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		initUserAuthority () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/initUserAuthority`
			}).then(res => {
				if (res.result === true) {
					this.getAuthority('07_0002_0000_00,07_0001_0000_00,09_0001_0000_00,null,14_0001_0000_00')
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
						switch (a[i]) {
						case '07_0001_0001_00':
							this.orderMenu[0].authorityShow = true
							break
						case '07_0001_0002_00':
							this.orderMenu[0].countFlag = true
							break
						case '07_0001_0004_00':
							this.orderMenu[1].authorityShow = true
							break
						case '07_0001_0005_00':
							this.orderMenu[1].countFlag = true
							break
						case '07_0001_0007_00':
							this.orderMenu[2].authorityShow = true
							break
						case '07_0001_0008_00':
							this.orderMenu[2].countFlag = true
							break
						case '07_0001_0010_00':
							this.orderMenu[3].authorityShow = true
							break
						case '07_0001_0011_00':
							this.orderMenu[3].countFlag = true
							break
						case '07_0002_0000_00':
							this.orderMenu[4].authorityShow = true
							break
						case '12_0001_0000_00':
							this.AuthorityList['12_0001_0000_00'] = true
							break
						case '14_0001_0000_00':
							this.AuthorityList['14_0001_0000_00'] = true
							break
						case '14_0002_0000_00':
							this.AuthorityList['14_0002_0000_00'] = true
							break
						}
					}
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		goDetail (item) {
			let a = JSON.parse(item.extras)
			if (item.refundOrderNumber) {
				if (a.billState === '0' && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '1' && !this.AuthorityList['07_0002_0007_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '2' && !this.AuthorityList['07_0002_0010_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '3' && !this.AuthorityList['07_0002_0013_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '4' && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				a.refundid = a.refundOrderId
				let b = JSON.stringify(a)
				window.sessionStorage.setItem('refundOrderParams', b)
				let shopid = ''
				this.shopOptions.forEach(e => {
					if (this.sellerShopId === e.organid) {
						shopid = e.shopId
					}
				})
				let refundTab = { orderStatus: a.billState, active: '', shopId: shopid }
				window.sessionStorage.setItem('refundTab', JSON.stringify(refundTab))
				this.$router.push({ path: 'refundOrderDetail' })
			} else {
				if (a.billState === '0' && !this.AuthorityList['07_0001_0001_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '1' && !this.AuthorityList['07_0001_0004_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '2' && a.isSellerpull === '0' && !this.AuthorityList['07_0001_0007_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '2' && a.isSellerpull === '1' && !this.AuthorityList['07_0001_0010_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '3' && !this.AuthorityList['07_0001_0013_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '4' && !this.AuthorityList['07_0001_0016_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '5' && !this.AuthorityList['07_0001_0019_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				let params = {}
				let billState = ''
				switch (a.billState) {
				case '0':
					billState = '待付款'
					break
				case '1':
					billState = '待接单'
					break
				case '2':
					billState = a.isSellerpull === '1' ? '备货中' : '待发货'
					break
				case '3':
					billState = '待收货'
					break
				case '4':
					billState = '已完成'
					break
				case '5':
					billState = '已取消'
					break
				}
				params.orderId = a.orderid
				params.statusId = a.statusid
				params.differ = a.differ
				params.buypullstate = a.buypullstate
				params.billState = billState
				params.messageid = a.messageId
				let orderParams = JSON.stringify(params)
				let aaa = { isSellerpull: a.isSellerpull === '1' }
				window.sessionStorage.setItem('tabInfo', JSON.stringify(aaa))
				window.sessionStorage.setItem('orderInfo', orderParams)
				this.$router.push('/main/orderDetail')
			}
		},
		changeType (value) {
			if (this.checkTime()) {
				this.getDrawData()
			}
		},
		shopChange (item) {
			this.shopOptions.forEach(e => {
				if (item === e.organid) {
					this.shopid = e.shopId
				}
			})
			this.getCurrentData()
			this.findCount()
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrent()]
			this.getDrawData()
			this.getMessage()
			window.sessionStorage.setItem('organid', this.sellerShopId)
		},
		changeShop (num) {
			this.enterpriseDataFlag = num
			this.getCurrentData()
			this.findCount()
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrent()]
			this.getDrawData()
			this.getMessage()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		getMessage () {
			let params = {
				bsflag: 1,
				msgtype: 1,
				start: 0,
				length: 3,
				organid: this.sellerShopId,
				enterpriseDataFlag: this.enterpriseDataFlag
			}
			this.$store.dispatch('requestPost', {
				// api: 'urlFS',
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/get`,
				data: params,
				loading: false
			}).then(res => {
				if (res.result === true) {
					if (this.AuthorityList['12_0001_0000_00']) {
						this.count = res.data.bussinessCount.count
						this.msgList = res.data.bussinessMessage
					} else {
						this.count = '0'
						this.msgList = []
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		goOrder (item) {
			if (item.name === '退货单') {
				if (item.authorityShow) {
					let tabParams = {}
					tabParams.active = '全部退单'
					tabParams.orderStatus = 0
					// tabParams.shopId = this.shopid
					tabParams.origin = 'home'
					window.sessionStorage.setItem('refundTab', JSON.stringify(tabParams))
					this.$router.push('/main/refundOrder')
				} else {
					this.$message.error('您没有查看退货单的权限!')
				}
			} else {
				if (!item.countFlag) {
					this.$message.error(`您没有查看${item.name}订单的权限!`)
					return false
				}
				let tabParams = {}
				tabParams.active = item.name
				tabParams.isSellerpull = item.isSellerpull
				tabParams.orderStatus = item.orderStatus
				// tabParams.sellerShopId = this.shopid
				// tabParams.origin = 'home'
				window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
				this.$router.push('/main/order')
			}
		},
		goRouter (route, num, authority) {
			if (num === 2) {
				if (!this.AuthorityList[authority]) {
					this.$message.error('您没有查看该报表的权限!')
					return false
				}
				let app = window.sessionStorage.getItem('app')
				if (app === 'scm8') {
					let params = {
						app: 'jsd',
						action: 'goBlank',
						data: {
							path: route,
							query: '',
							id: '11',
							title: '报表'
						}
					}
					window.parent.postMessage(params, '*')
				} else {
					this.$fxGoBlank(`/${route}`, this.$router)
				}
			} else if (num === 3) {
				if (!this.AuthorityList[authority]) {
					this.$message.error('您没有查看消息中心的权限!')
					return false
				}
				let _path = `/main/${route}`
				this.$router.push(_path)
			} else {
				let _path = `/main/${route}`
				this.$router.push(_path)
			}
		},
		drawLine () {
			var echarts = require('echarts')
			let myChart = this.$echarts.init(document.getElementById('myChart'))
			var that = this
			const primaryColor = this.$fxPrimaryColor || '#409eff'
			const primaryColorFaded = primaryColor + '0d'
			// console.log(this.dateNunber)
			let option = {
				backgroundColor: '#fff',
				title: {
					text: '',
					left: 'center',
					bottom: '5%',
					textStyle: {
						color: '#000',
						fontSize: 16
					}
				},
				grid: {
					top: '17%',
					left: '2%',
					right: '5%',
					bottom: '10%',
					containLabel: true
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: function (params) {
						var htmlStr = '<div>'
						htmlStr += params[0].name + '<br/>' // x轴的名称
						htmlStr += params[0].value + (that.value === '2' ? '%' : '')
						htmlStr += '</div>'
						return htmlStr
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: this.dateTime,
					axisLabel: {
						margin: 15,
						color: '#333'
					},
					axisLine: {
						show: false
					},
					axisTick: {
						show: true,
						length: 0,
						lineStyle: {
							color: '#000'
						}
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: '#ECECEC'
						}
					}
				},
				yAxis: [{
					type: 'value',
					position: 'left',
					axisLabel: {
						margin: 20,
						color: '#333'
					},
					axisTick: {
						show: true,
						length: 0,
						lineStyle: {
							color: '#000'
						}
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: '#ECECEC'
						}
					},
					axisLine: {
						lineStyle: {
							color: '#ECECEC',
							width: 1
						}
					}
				}],
				series: [{
					name: '',
					type: 'line',
					smooth: true,
					showAllSymbol: true,
					symbol: 'circle',
					symbolSize: 4,
					lineStyle: {
						normal: {
							color: primaryColor
						}
					},
					label: {
						show: false,
						position: 'top',
						textStyle: {
							color: 'grey'
						}
					},
					itemStyle: {
						color: primaryColor,
						borderColor: primaryColor,
						borderWidth: 1
					},
					tooltip: {
						show: true,
						trigger: 'axis'
					},
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: primaryColor
							}, {
								offset: 1,
								color: primaryColorFaded
							}], false)
						}
					},
					data: this.dateNunber
				}]
			}
			myChart.setOption(option, true)
		},
		chartssize (container, charts) {
			var wi = this.getStyle(container, 'width').width
			var hi = this.getStyle(container, 'height').height
			charts.style.width = wi
			charts.style.height = hi
		},
		getStyle (el, name) {
			if (window.getComputedStyle) {
				return window.getComputedStyle(el, null)
			} else {
				return el.currentStyle
			}
		},
		downloadFile () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/%E6%9E%81%E9%80%9F%E8%AE%A22.0-%E5%8D%96%E5%AE%B6%E5%90%8E%E5%8F%B0%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.docx?timeStamp=' + new Date().getTime()
			window.location.href = url
		}
	}
}
</script>
<style lang="stylus" scoped>
.home {
	flex: 1
	background-color: #eceffc!important
	padding: 0px!important
	overflow: hidden
	@media screen and (min-width: 1366px) {
		.order-detail>div span {
			right: 15px!important
		}
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		background-color: #fff
		padding-left: 15px
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.home-container {
		overflow-y: auto;
		height: 100%
	}
	.info-box {
		background-color: #fff;
		padding: 0 15px;
		box-sizing: border-box
		.info-child-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer
			.el-dropdown {
				img {
					width: 16px;
					height: 15px;
					padding-right:5px;
				}
				.el-dropdown-link {
					color: var(--fx-primary-color);
					display: flex;
					align-items: center;
				}
			}
		}
	}
	.all-info-title{
		background-color: #fff
		height: 50px
		line-height: 50px
		font-size: 18px
		font-weight: bold
		text-align: left
		text-indent: 15px
	}
	.allinfo-detail{
		background-color: #fff
		display: flex
		padding: 35px 0
		&>div{
			flex: 1
			.allinfo-wrap{
				text-align: center
				.info-name{
					color: var(--fx-primary-color)
					font-size: 14px
				}
				.info-figure{
					color: #595959
					height: 35px
					span{
						font-weight: bold
						font-size: 18px
					}
				}
			}
		}
	}
	.home-title{
		display: flex
		align-items: center
		height: 50px
		// padding: 0 15px 0 20px
		padding-left: 10px;
		font-size: 16px
		font-weight: bold
		border-bottom: 1px solid #eee
		position: relative
		&:before {
			content: '';
			width: 3px;
			height: 18px;
			background: var(--fx-primary-color);
			left: 0;
			position: absolute;
			top: 17px;
		}
		.unread-count{
			// width: 100px
			// height: 20px
			// line-height: 20px
			padding: 4px 10px;
			background-color: #EAF3FF
			color: var(--fx-primary-color)
			border-radius: 12px
			font-size: 14px
			font-weight: normal
			margin-left: 15px
		}
		.home-titmore{
			margin-left: auto
			color: #999
			font-size: 14px
			font-weight: normal
			cursor: pointer
		}
	}
	.home-left{
		width: 75%
		float: left
		// margin-top: 15px
		margin-right: 1%
		.home-chart{
			position: relative
			width: 100%
			height: 490px
			// padding: 0 15px;
			// box-sizing: border-box
			background-color: #fff
			.chart-month{
				position: absolute
				width: 330px
				top: 68px
				right: 5%
				display: flex;
				align-items: center;
				.time-input {
					width: 280px;
					margin-left: 10px;
				}
				span{
					font-size: 14px
				}
			}
			.chart-order{
				display: flex
				align-items: center
				position: absolute
				// width: 160px
				top: 70px
				left: 5%
				span{
					margin-left: 15px
					font-size: 14px
				}
			}
		}
		.home-order{
			width: 100%
			height: 200px
			margin: 10px 0
			display: flex
			.order-content{
				width: 55%
				margin-right: 1%
				background-color: #fff
				padding: 0 15px;
				box-sizing: border-box
				.order-detail{
					display: flex
					&>div{
						padding: 28px 10px
						width: 20%
						box-sizing: border-box
						font-size: 14px
						position: relative
						.img-wrap {
							height: 60px
							margin-bottom: 15px
							display: flex
							align-items: center
						}
						img{
							width: 60px
							height: auto
							max-width: 100%
							margin: 0 auto
							// border-radius: 50%
							// margin-bottom: 10px
							cursor: pointer
						}
						span{
							position: absolute
							// width: 35px
							height: 18px
							padding: 0 6px;
							text-align: center
							line-height: 20px
							background-color: #FC5656
							border-radius: 30px
							color: #fff
							top: 25px
							right: 10px
						}
					}
				}
			}
			.form-content{
				width: 44%
				background-color: #fff
				padding: 0 15px;
				box-sizing: border-box
				.form-detail{
					display: flex
					&>div{
						padding: 28px 10px
						width: 25%
						box-sizing: border-box
						font-size: 14px
						img{
							width: 60px
							height: 60px
							margin: 0 auto
							// border-radius: 50%
							margin-bottom: 15px
							cursor: pointer
						}
					}
				}
			}
		}
	}
	.home-right{
		width: 24%
		float: left
		box-sizing: border-box
		// margin-top: 15px
		.ad-box {
			width: 100%;
			height: 175px;
			margin-bottom: 10px;
			.ad-img {
				width: 100%;
				height: 100%;
				cursor: pointer
			}
		}
		.waring-box{
			width: 100%
			height: 170px
			padding: 0 15px;
			margin: 10px 0
			background-color: #fff
			box-sizing: border-box
			cursor: pointer
			.waring-detial{
				flex: 1;
				display: flex;
				flex-direction: column
				.waring-title{
					display: flex;
					align-items: center;
					height: 40px;
					font-size: 14px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #333333;
				}
				.waring-text{
					text-align: left;
					margin-top: 10px;
					font-size: 14px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #595959;
				}
			}
		}
		.home-message{
			width: 100%
			padding: 0 15px;
			box-sizing: border-box
			background-color: #fff
			margin-bottom: 10px
			overflow: hidden
			.home-msg-content{
				// padding: 0 10px
				text-align: left
				.home-msg-detail{
					background-color: #F6FAFF
					padding: 10px
					// padding-bottom: 0
					margin-top: 10px
					position: relative
					cursor: pointer
					.home-msg-first{
						color: #333
						font-weight: bold
						font-size: 14px
					}
					.home-msg-second{
						color: #595959
						line-height: 40px
					}
					.home-msg-third{
						display: flex
						align-items: center
						// border-top: 1px solid #E9EBEF
						height: 25px
						color: #999
						span{
							margin-left: auto
						}
					}
					.unread-sign{
						position: absolute
						top: 7px
						right: 10px
						color: var(--fx-primary-color)
						font-size: 14px;
						font-weight: bold
						border-radius: 30px
						background-color: #DFEDFF
						padding: 3px 12px
					}
				}
			}
		}
		.home-account {
			padding: 0 15px;
			box-sizing: border-box
			background-color: #fff
			margin-bottom: 10px
			.account-info {
				padding: 0 0 19px 10px;
				text-align: left;
				color: #333
				font-size: 14px
				&>div {
					margin-top: 16px;
					span {
						color: #595959
					}
				}
			}
			.changeShop {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.shop-box {
					display: inline-block;
					margin-right: 20px
					position: relative
					cursor: pointer
					color: var(--fx-primary-color)
					font-size: 14px
					.shop-pull-box {
						position: absolute;
						top:0;
						left: 0;
						bottom: 0;
						right: 0;
						opacity: 0
					}
				}
			}
		}
		.home-download{
			width: 100%
			height: 160px
			padding: 0 15px;
			box-sizing: border-box
			background-color: #fff
			// margin-bottom: 10px
			.home-manage{
				display: flex
				padding-left: 10px
				.home-manage-manual{
					margin-top: 20px
					color: #595959
					font-size: 14px
					a{
						text-decoration: underline;
						display: block;
						margin-bottom: 20px;
					}
				}
			}
		}
	}
	.detail-dialog-title {
		text-align: left;
		.tip-text {
			line-height: 26px
		}
		.tip-btn {
			margin-top: 40px;
			text-align: center
		}
	}
}
</style>
<style lang="stylus">
	.ad-dialog {
		height: 0;
		.el-dialog__title {
			display: none;
		}
	}
	.ad-detail {
		position: absolute;
		top: 0;
		left: 0
		width:100%;
		height: 594.75px;
		z-index: -1
	}
</style>
